import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { ProductIntro } from '../components/ProductIntro';
import { WhySupplementsFail } from '../components/WhySupplementsFail';
import { WhatsInside } from '../components/WhatsInside';
import { WhoItsFor } from '../components/WhoItsFor';
import { WhatMakesDifferent } from '../components/WhatMakesDifferent';
import { BonusSection } from '../components/BonusSection';
import { Transformation } from '../components/Transformation';
import { PersonalizedHelp } from '../components/PersonalizedHelp';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function SupplementLandingPage() {
  return <div className="min-h-screen bg-cream overflow-x-hidden selection:bg-primary/20 selection:text-primary-dark" data-id="element-264">
      <Hero data-id="element-265" />
      <PainPoints data-id="element-266" />
      <ProductIntro data-id="element-267" />
      <WhySupplementsFail data-id="element-268" />
      <WhatsInside data-id="element-269" />
      <WhoItsFor data-id="element-270" />
      <WhatMakesDifferent data-id="element-271" />
      <BonusSection data-id="element-272" />
      <Transformation data-id="element-273" />
      <PersonalizedHelp data-id="element-274" />
      <FinalCTA data-id="element-275" />
      <Footer data-id="element-276" />
    </div>;
}